'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/components/buttons/ThemeButton.tsx
import { Button as BaseButton } from "@wbk/ui";
import { twMerge } from "tailwind-merge";
import { jsx } from "react/jsx-runtime";
var ThemeButton = (props) => {
  return /* @__PURE__ */ jsx(BaseButton, __spreadProps(__spreadValues({}, props), { className: twMerge("rounded-radius", props.className) }));
};
var ThemeButton_default = ThemeButton;

export {
  ThemeButton_default
};
//# sourceMappingURL=chunk-VYWHMVWT.mjs.map